/**
 * Radio — DS Atom
 */

import styles from './Radio.module.css';

interface RadioOption {
  value: string;
  label: string;
}

interface RadioProps {
  name: string;
  options: RadioOption[];
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

export function Radio({ name, options, value, onChange, disabled = false, className = '' }: RadioProps) {
  return (
    <div className={`${styles.group} ${className}`}>
      {options.map(opt => (
        <div key={opt.value} className={styles.wrapper}>
          <input
            type="radio"
            id={`${name}-${opt.value}`}
            name={name}
            className={styles.input}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange?.(opt.value)}
            disabled={disabled}
          />
          <label className={styles.label} htmlFor={`${name}-${opt.value}`}>{opt.label}</label>
        </div>
      ))}
    </div>
  );
}
